export enum ExerciseRoutine {    
    Never = 0,
    Occasional = 1,
    TwoToThreePerWeek = 2,
    FourToSixPerWeek = 3,
    Daily = 4
}